

import log from 'loglevel';

// Set the desired log level. Options are: 'trace', 'debug', 'info', 'warn', 'error', 'silent'
log.setLevel('debug');

// Export the logger instance for use in other modules
export default log;